import React, { useEffect, useState } from 'react';
// import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import { Button } from 'reactstrap';
import { Modal } from '../../../components/ui/Modal';
import { selectFilters } from '../filters/filtersSlice';
import { loadAllClients, loadCustomerTypes, loadWebbAppVersion, selectClientsState } from '../clients/clientsSlice';
import { useAppDispatch, useAppSelector } from '../hooks';
import { HttpRequest } from '../../../util/http';
import { userData } from '../../../util/userData/index'
import { ClientTable } from '../ModalComponent/clientTable';
import { NewClient } from '../ModalComponent/newClient';
import { CustomerType } from '../ModalComponent/customerType';
import { DynamicAge } from '../ModalComponent/dynamicAge';
import { IpAccess } from '../ModalComponent/ipAccess';
import { EditPermission } from '../ModalComponent/editPermission';
import { EditClient } from '../ModalComponent/editClient';
import { DashboardSelectorComponent } from '../utils/dashboardSelectorComponent';




export function ClientDashboardComponent() {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(
    selectFilters
  )
  const allClients = useAppSelector(selectClientsState);
  const { isLoading, apiResponse, allClientData, customerTypes, allStatus, webAppVersion } = allClients;
  const [clientsData, setClientsData] = useState(allClientData);
  const [allClientStatus, setAllClientStatus] = useState("");
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [isDashboardModalOpen, setIsDashboardModalOpen] = useState(false);
  const [isSyncSuperUsersModalOpen, setIsSyncSuperUsersModalOpen] = useState(false);

  const toggleDashboardModal = () => setIsDashboardModalOpen(!isDashboardModalOpen);

  useEffect(() => {
    dispatch(loadAllClients("0"))
    dispatch(loadCustomerTypes())
    dispatch(loadWebbAppVersion())

  }, [])

  useEffect(() => {
    setClientsData(allClientData)
  }, [allClientData])

  useEffect(() => {
    setAllClientStatus(allStatus)
  }, [allClientData])

  const [filteredClients, setFilteredClients] = useState(clientsData);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setFilteredClients(clientsData)
  }, [clientsData])

  useEffect(() => {
    const filteredRows = clientsData.filter((row) => {
      const results = (
        row.name.toLowerCase().includes(search.toLowerCase()) ||
        row.abbr.toLowerCase().includes(search.toLowerCase())
      )
      return results
    });
    setFilteredClients(filteredRows);
  }, [search]);

  // Clear Local State
  function clearLocalState() {
    setModalAbbr("");
    setModalBankName("");
    setModalCustomerType("");
    setModalCustomerTypeValue("1");
    setDynamicAge(0);
    setIpRestrictions([]);
    setIpAddress("");
    setDomain("");
    setModalStatus("");
    setBaseQuestion(false);
    setClassicQuestions(false);
    setRankingReport(false);
    setEditCommentCodes(false);
    setEditDetails(false);
    setAdvanceActionAlert(false);
    setActionAlerts(false);
    setUsesSampleApp(false);
    setJhInstRouteId("");
    setJhInstEnv("");
    setRespondentName("");
    setRespondentEmail("");
    setRespondentPhone("");
    setSelectAllSurvey("");
    setSelectAllSurveyValue("");
    setSelectSingleSurvey([]);
    setAllSurveyQuestions([]);
    setAllSurveyQuestionsQID("");
    setAllSurveyQuestionValue("");
    setSingleSurveyQuestions([]);
    setSingleSurveyQuestionsValues([]);
    setDefaultPeriod("");
    setPermissionsAbbr("");
    setFlagAbility(false);
    setHasAccessToCustomDateRanges(false);
    setHasApiAccess(false);
    setHasMFAEnabled(false);
    setSelfServeAbility(false);
    setHasExportAcess(false);
    setHasNotesAccess(false);
    setPermissions([]);
    setSelectDefaultPeriod([]);
    setPermissionPeriods([]);
    setPermissionKeys([]);
  }

  // -- Status for Clients --
  const allClientsStatusHandleChange = event => {
    let stat = event.target.value
    setAllClientStatus(stat)
    dispatch(loadAllClients(stat))

  };

  // -- Add New Client --
  const [newClientModal, setNewClientModal] = useState(false);

  const addNewClient = () => {
    setIsDataLoading(true)
    var data = {
      'abbr': modalAbbr,
      'client': modalBankName
    };
    const method = 'POST';
    return HttpRequest.fetch<any>('/scripts/clients/add2', { data, method })
      .then((res) => {
        setIsDataLoading(false);
        setMessage(res.message);
        setNewClientModal(false);
        dispatch(loadAllClients(allClientStatus));
        setSearch("");
        clearLocalState();
      })
  }


  // -- Client Type Modal State --
  const [clientTypeModal, setClientTypeModal] = useState(false);
  const [modalAbbr, setModalAbbr] = useState("");
  const [modalBankName, setModalBankName] = useState("");
  const [modalCustomerType, setModalCustomerType] = useState("");
  const [modalCustomerTypeValue, setModalCustomerTypeValue] = useState("1");
  const [message, setMessage] = useState("");

  const modifyCustomerType = (name, abbr, customerTypes) => {
    setModalBankName(name);
    setIsDataLoading(true);
    var data = { abbr };
    const method = 'POST';
    return HttpRequest.fetch<any>('/scripts/clients/get_one', { data, method })
      .then((res) => {
        setIsDataLoading(false)
        setClientTypeModal(true);
        setModalAbbr(res.abbr);
        setModalCustomerTypeValue(res.customer_type);
        const id = Number(res.customer_type)
        for (var i = 0; i < customerTypes.length; i++) {
          var customer_types = customerTypes[i];
          if (Number(customer_types.id) === id) {
            setModalCustomerType(customer_types.name)
          }
        }
      })
  }

  const customerTypeHandleChange = event => {
    const id = Number(event.target.value)
    setModalCustomerTypeValue(event.target.value)
    for (var i = 0; i < customerTypes.length; i++) {
      var customer_types = customerTypes[i];
      if (Number(customer_types.id) === id) {
        setModalCustomerType(customer_types.name)
      }
    }
  };

  const saveCustomerClientType = (modalAbbr, modalCustomerType, modalCustomerTypeValue, allClientData) => {
    setIsDataLoading(true)
    var data = {
      'abbr': modalAbbr,
      'customer_type': modalCustomerTypeValue
    };
    const method = 'POST';
    return HttpRequest.fetch<any>('/scripts/clients/modify_customer_type', { data, method })
      .then((res) => {
        setIsDataLoading(false)
        setMessage(res.message)
        setTimeout(() => {
          dispatch(loadAllClients(allClientStatus))
          setSearch("")
          setClientTypeModal(false)
          clearLocalState()
        }, 200)

      })
  }

  // -- Dynamic Age Modal State --
  const [dynamicAgeModal, setDynamicAgeModal] = useState(false);
  const [dynamicAge, setDynamicAge] = useState(0);

  const handleInputCounter = event => {
    setDynamicAge(event.target.value);
  };

  const modifyDynamicAge = (name, abbr, dynamic_age) => {
    setModalBankName(name);
    setModalAbbr(abbr);
    setDynamicAgeModal(true);
    setDynamicAge(dynamic_age);
  }

  const saveDynamicAge = () => {
    setIsDataLoading(true)
    var data = {
      'abbr': modalAbbr,
      'dynamiceAge': dynamicAge
    };
    const method = 'POST';
    return HttpRequest.fetch<any>('/scripts/clients/update_dynamic_age', { data, method })
      .then((res) => {
        setIsDataLoading(false)
        setMessage(res.message)
        setTimeout(() => {
          setDynamicAgeModal(false)
          dispatch(loadAllClients(allClientStatus))
          setSearch("")
          clearLocalState()
        }, 200)
      })
  }

  // -- Questionaires --
  function redirectToUrl(page, display?) {
    if (!display) {
      display = page.replace('.php', '');
      if (display.indexOf('?') > -1)
        display = display.substring(0, display.indexOf('?'));
      display = display.replace(/_/g, " ");
    }
    window.location = page;
  }

  const redirectToQuestionnaires = (abbr) => {

    var data = {
      'project': abbr
    };
    const method = 'POST';
    return HttpRequest.fetch<any>('/scripts/users/change_project', { data, method })
      .then((res) => {
        // @ts-ignore
        userData.storeUserDataInSession('current_project', abbr);
        // @ts-ignore
        userData.storeUserDataInSession('client', abbr);
        redirectToUrl('surveys');
      })
  }

  // -- IP Restriction --
  const [ipRestrictionModal, setIpRestrictionModal] = useState(false);
  const [ipRestriction, setIpRestrictions] = useState([]);
  const [ipRestrictionLoading, setIpRestrictionLoading] = useState(false);
  const [addIpModal, setAddIpModal] = useState(false);
  const [ipAddress, setIpAddress] = useState("");

  const loadIpRestrictions = (abbr, name) => {
    setIsDataLoading(true);
    setModalAbbr(abbr);
    setModalBankName(name);
    setIpRestrictionModal(true);
    var data = {
      'project': abbr
    };
    const method = 'POST';
    return HttpRequest.fetch<any>('/scripts/clients/ip_restrictions', { data, method })
      .then((res) => {
        setIsDataLoading(false);
        setIpRestrictions(res);

      })

  }

  const ipAddressHandleOnChange = event => {
    setIpAddress(event.target.value);
  };

  const closeIPModal = () => {
    setIpRestrictionModal(false)
    clearLocalState()
  }


  const saveIpRestrictionModal = () => {
    setIsDataLoading(true);
    var data = {
      'project': modalAbbr,
      'ipMask': ipAddress
    };
    const method = 'POST';
    return HttpRequest.fetch<any>('/scripts/clients/add_ip_restriction', { data, method })
      .then((res) => {
        setIsDataLoading(false);
        setIpRestrictions(res.ipAddresses);
        setAddIpModal(false);
        setIpAddress("");
        if (res.ipAddresses.length > 1) {
          let newClientData = [];
          for (var i = 0; i < allClientData.length; i++) {
            var client = allClientData[i];
            if (client.abbr === modalAbbr) {
              const obj = {
                'name': client.name,
                'abbr': client.abbr,
                'customer_type': client.customer_type,
                'dynamic_age': client.dynamic_age,
                'default_dashboard': client.default_dashboard,
                'restricted': 'Yes',
                'latestLoad': client.latestLoad,
                'default_page_id': client.default_page_id,
                'all_surveys_default_question_qid': client.all_surveys_default_question_qid,
                'all_surveys_default_question_val': client.all_surveys_default_question_val,
                'default_questions': client.default_questions,
                'classic_customer': client.classic_customer,
                'allowBaseQuestion': client.allowBaseQuestion,
                'default_url': client.default_url,
                'domain': client.domain,
                'editcommentcodes': client.editcommentcodes,
                'editdetails': client.editdetails,
                'enableActionAlertUpdates': client.enableActionAlertUpdates,
                'enableActionAlerts': client.enableActionAlerts,
                'enableRankingReports': client.enableRankingReports,
                'respondentEmail': client.respondentEmail,
                'respondentName': client.respondentName,
                'respondentPhone': client.respondentPhone,
                'status': client.status
              };
              newClientData.push(obj);
            }
          }
          const res2 = allClientData.filter((data1) => !newClientData.some(data2 => data1.abbr === data2.abbr))
          Array.prototype.push.apply(newClientData, res2);
          newClientData.sort((a, b) => a.name.localeCompare(b.name));
          setFilteredClients(newClientData);
        }
      })
  }

  const removeIpRestriction = (deleteIp) => {
    setIsDataLoading(true);
    var data = {
      'project': modalAbbr,
      'ipMask': deleteIp
    };
    const method = 'POST';
    return HttpRequest.fetch<any>('/scripts/clients/delete_ip_restriction', { data, method })
      .then((res) => {
        console.log(res, 'res from delete')
        setIsDataLoading(false);
        setIpRestrictions(res.ipAddresses);
        if (res.ipAddresses.length <= 1 || res.ipAddresses === undefined) {
          let newClientData = [];
          for (var i = 0; i < allClientData.length; i++) {
            var client = allClientData[i];
            if (client.abbr === modalAbbr) {
              const obj = {
                'name': client.name,
                'abbr': client.abbr,
                'customer_type': client.customer_type,
                'dynamic_age': client.dynamic_age,
                'default_dashboard': client.default_dashboard,
                'restricted': 'No',
                'latestLoad': client.latestLoad,
                'default_page_id': client.default_page_id,
                'all_surveys_default_question_qid': client.all_surveys_default_question_qid,
                'all_surveys_default_question_val': client.all_surveys_default_question_val,
                'default_questions': client.default_questions,
                'classic_customer': client.classic_customer,
                'allowBaseQuestion': client.allowBaseQuestion,
                'default_url': client.default_url,
                'domain': client.domain,
                'editcommentcodes': client.editcommentcodes,
                'editdetails': client.editdetails,
                'enableActionAlertUpdates': client.enableActionAlertUpdates,
                'enableActionAlerts': client.enableActionAlerts,
                'enableRankingReports': client.enableRankingReports,
                'respondentEmail': client.respondentEmail,
                'respondentName': client.respondentName,
                'respondentPhone': client.respondentPhone,
                'status': client.status
              };
              newClientData.push(obj);
            }
          }
          const res2 = allClientData.filter((data1) => !newClientData.some(data2 => data1.abbr === data2.abbr))
          Array.prototype.push.apply(newClientData, res2);
          newClientData.sort((a, b) => a.name.localeCompare(b.name));
          setFilteredClients(newClientData);
        }
      })
  }

  // -- Edit Client Modal --
  const [editClientModal, setEditClientModal] = useState(false);
  const [domain, setDomain] = useState('');
  const [modalStatus, setModalStatus] = useState('');
  const [baseQuestions, setBaseQuestion] = useState(false);
  const [classicQuestions, setClassicQuestions] = useState(false);
  const [rankingReport, setRankingReport] = useState(false);
  const [editCommentCodes, setEditCommentCodes] = useState(false);
  const [editDetails, setEditDetails] = useState(false);
  const [advanceActionAlert, setAdvanceActionAlert] = useState(false);
  const [actionAlerts, setActionAlerts] = useState(false);
  const [individualSurveysDelete, setIndividualSurveysDelete] = useState(false);
  const [respondentName, setRespondentName] = useState('');
  const [respondentEmail, setRespondentEmail] = useState('');
  const [respondentPhone, setRespondentPhone] = useState('');
  const [selectAllSurvey, setSelectAllSurvey] = useState('');
  const [selectAllSurveyValue, setSelectAllSurveyValue] = useState('');
  const [selectSingleSurvey, setSelectSingleSurvey] = useState([]);
  const [allSurveyQuestions, setAllSurveyQuestions] = useState([]);
  const [allSurveyQuestionsQID, setAllSurveyQuestionsQID] = useState('');
  const [allSurveyQuestionValue, setAllSurveyQuestionValue] = useState('');
  const [singleSurveyQuestions, setSingleSurveyQuestions] = useState([]);
  const [singleSurveyQuestionsValues, setSingleSurveyQuestionsValues] = useState([]);
  const [usesSampleApp, setUsesSampleApp] = useState(false);
  const [jhInstRouteId, setJhInstRouteId] = useState('');
  const [jhInstEnv, setJhInstEnv] = useState('');

  const closeEditClientModal = () => {
    setEditClientModal(false)
    clearLocalState()
  }

  const classicQuestionAttribute = (classicQuestions, singleSurveyQuestions) => {
    setClassicQuestions(!classicQuestions)
    let value = (!classicQuestions)
    if (!value) {
      document.getElementById('allQuestionSelect').removeAttribute("disabled")
      document.getElementById('singleQuestionSelect').removeAttribute("disabled")
    } else {
      document.getElementById('allQuestionSelect').setAttribute('disabled', 'true');
      document.getElementById('singleQuestionSelect').setAttribute('disabled', 'true');
      const qvalue1 = '5#T2';
      const qvalue2 = '17#T2';
      const qvalue3 = '15_8#T2';
      const qvalue4 = '16#T2';
      let newSingleSurveyQuestions = [];
      let newSingleSurveyQuestionsValues = []
      for (var i = 0; i < singleSurveyQuestions.length; i++) {
        var question = singleSurveyQuestions[i];
        if (question.value === qvalue1 || question.value === qvalue2 || question.value === qvalue3 || question.value === qvalue4) {
          const obj = { 'value': question.value, 'text': question.text, 'selected': true };
          newSingleSurveyQuestions.push(obj);
          newSingleSurveyQuestionsValues.push(question.value);

        }
        else {
          const obj = { 'value': question.value, 'text': question.text, 'selected': false };
          newSingleSurveyQuestions.push(obj);
        }
      }
      setSelectAllSurveyValue('5#T2')
      setAllSurveyQuestionsQID('5');
      setAllSurveyQuestionValue('T2');
      setSingleSurveyQuestions(newSingleSurveyQuestions)
      setSingleSurveyQuestionsValues(newSingleSurveyQuestionsValues)

    }
  }


  const getCategories = (id, name, abbr, customer_type, customer_type_id, dynamic_age, default_dashboard, restricted, latestLoad, default_page_id, all_surveys_default_question_qid, all_surveys_default_question_val, default_questions, classic_customer, allowBaseQuestion, default_url, domain, editcommentcodes, editdetails, enableActionAlertUpdates, enableActionAlerts, enableRankingReports, respondentEmail, respondentName, respondentPhone, status, enableIndividualSurveysDelete, usesSampleApp, jhInstRouteId, jhInstEnv) => {
    setIsDataLoading(true);
    setEditClientModal(true);
    setModalBankName(name);
    setModalAbbr(abbr);
    setDomain(domain);
    setModalStatus(status);
    setModalCustomerType(customer_type);
    setDynamicAge(dynamic_age);
    setBaseQuestion(allowBaseQuestion);
    setClassicQuestions(classic_customer);
    setRankingReport(enableRankingReports);
    setEditCommentCodes(editcommentcodes);
    setEditDetails(editdetails);
    setAdvanceActionAlert(enableActionAlertUpdates);
    setActionAlerts(enableActionAlerts);
    setRespondentName(respondentName);
    setRespondentEmail(respondentEmail);
    setRespondentPhone(respondentPhone);
    setModalCustomerTypeValue(customer_type_id)
    setIndividualSurveysDelete(enableIndividualSurveysDelete);
    setUsesSampleApp(usesSampleApp);
    setJhInstRouteId(jhInstRouteId || '');
    setJhInstEnv(jhInstEnv || '');

    const all_surveys_default_question = all_surveys_default_question_qid + '#' + all_surveys_default_question_val;
    let single_survey_default_questions = '';
    if (default_questions === null || default_questions === undefined || default_questions === '') {
      single_survey_default_questions = '';
    } else {
      single_survey_default_questions = default_questions.split(',');
    }
    var data = {
      'client_abbr': abbr
    };
    const method = 'POST';
    return HttpRequest.fetch<any>('/scripts/categories_all', { data, method })
      .then((res) => {
        const allSurvey = [];
        const singleSurvey = [];
        let allSelectSurvey = '';
        let allSelectSurveyValue = '';
        let allSelectSurveyQID = '';
        let allSelectSurveyQuestionValue = '';
        let singleSelectSurvey = [];
        let singleSelectSurveyValue = []
        if (res.values.length <= 1) {
          console.log('Survey Questions are not set');
        } else {
          res.values.forEach(function (category, cat_index) {
            category.children.forEach(function (child, child_index) {
              var value = category.qid + '#' + child.val;
              var allSurveysSelected = all_surveys_default_question === value;
              var text = category.display + ':  ' + child.label;
              var defaultCategorySelect = {
                value: value,
                text: text,
                selected: allSurveysSelected
              };
              allSurvey.push(defaultCategorySelect)
              if (all_surveys_default_question === value) {
                allSelectSurvey = text
                allSelectSurveyValue = value;
                allSelectSurveyQID = category.qid;
                allSelectSurveyQuestionValue = child.val;
              }
              var singleSurveyDefault = {
                value: value,
                text: text,
                selected: single_survey_default_questions.indexOf(value) >= 0
              };
              singleSurvey.push(singleSurveyDefault)
              if (single_survey_default_questions.indexOf(value) >= 0) {
                singleSelectSurvey.push(text);
                singleSelectSurveyValue.push(value);
              }
            });
          });
          setSelectAllSurvey(allSelectSurvey);
          setSelectAllSurveyValue(allSelectSurveyValue);
          setSelectSingleSurvey(singleSelectSurvey);
          setAllSurveyQuestions(allSurvey);
          setSingleSurveyQuestions(singleSurvey);
          setSingleSurveyQuestionsValues(singleSelectSurveyValue);
          setAllSurveyQuestionsQID(allSelectSurveyQID);
          setAllSurveyQuestionValue(allSelectSurveyQuestionValue);
          if (!classic_customer) {
            setTimeout(() => {
              document.getElementById('allQuestionSelect').removeAttribute("disabled")
              document.getElementById('singleQuestionSelect').removeAttribute("disabled")
            }, 100)
          }
        }
        setIsDataLoading(false);
        setUsesSampleApp(usesSampleApp);
      })
  }

  const allSurveyHandleChange = event => {
    let allSurvey = event.target.value;
    const array = allSurvey.split('#')
    setAllSurveyQuestionsQID(array[0]);
    setAllSurveyQuestionValue(array[1]);
    setSelectAllSurveyValue(allSurvey)
  };

  const singleSurveyHandleChange = (value, singleSurveyQuestions) => {
    let newSingleSurveyQuestions = [];
    let newSingleSurveyQuestionsValues = []
    for (var i = 0; i < singleSurveyQuestions.length; i++) {
      var question = singleSurveyQuestions[i];
      if (question.value === value) {
        const newSelected = !question.selected;
        const obj = { 'value': question.value, 'text': question.text, 'selected': newSelected };
        newSingleSurveyQuestions.push(obj);
        if (newSelected) {
          newSingleSurveyQuestionsValues.push(question.value);
        }
      }
      else {
        const obj = { 'value': question.value, 'text': question.text, 'selected': question.selected };
        newSingleSurveyQuestions.push(obj);
        if (question.selected) {
          newSingleSurveyQuestionsValues.push(question.value);
        }
      }
    }
    setSingleSurveyQuestions(newSingleSurveyQuestions)
    setSingleSurveyQuestionsValues(newSingleSurveyQuestionsValues)
  };

  const updateClient = () => {
    setIsDataLoading(true);
    const data = {
      'abbr': modalAbbr,
      'name': modalBankName,
      'domain': domain,
      'customerType': modalCustomerTypeValue,
      'dynamic_age': dynamicAge,
      'all_surveys_default_question_qid': allSurveyQuestionsQID,
      'all_surveys_default_question_val': allSurveyQuestionValue,
      'single_survey_default_questions': JSON.stringify(singleSurveyQuestionsValues),
      'classic_customer': Boolean(classicQuestions) ? 1 : 0,
      'allowBaseQuestion': Boolean(baseQuestions) ? 1 : 0,
      'enableActionAlertUpdates': Boolean(advanceActionAlert) ? 1 : 0,
      'enableRankingReports': Boolean(rankingReport) ? 1 : 0,
      'enableActionAlerts': Boolean(actionAlerts) ? 1 : 0,
      'respondentName': respondentName,
      'respondentEmail': respondentEmail,
      'respondentPhone': respondentPhone,
      'canEditComments': Boolean(editCommentCodes) ? 1 : 0,
      'canEditDetails': Boolean(editDetails) ? 1 : 0,
      'status': modalStatus,
      'enableIndividualSurveysDelete': Boolean(individualSurveysDelete) ? 1 : 0,
      'usesSampleApp': Boolean(usesSampleApp) ? 1 : 0,
      'jhInstRouteId': jhInstRouteId,
      'jhInstEnv': jhInstEnv,
    };

    const method = 'POST';
    return HttpRequest.fetch<any>('/scripts/clients/update', { data, method })
      .then((res) => {
        setMessage(res.message);
        setIsDataLoading(false);
        setTimeout(() => {
          dispatch(loadAllClients(allClientStatus))
          setSearch("")
          setEditClientModal(false)
          clearLocalState()
        }, 100)

      })

  }


  // -- Edit Permission Modal --
  const [editPermissionModal, setEditPermissionModal] = useState(false);
  const [defaultPeriod, setDefaultPeriod] = useState("");
  const [permissionsAbbr, setPermissionsAbbr] = useState("");
  const [flagAbility, setFlagAbility] = useState(false);
  const [hasAccessToCustomDateRanges, setHasAccessToCustomDateRanges] = useState(false);
  const [hasApiAccess, setHasApiAccess] = useState(false);
  const [hasMFAEnabled, setHasMFAEnabled] = useState(false);
  const [hasSelfServeAbility, setSelfServeAbility] = useState(false);
  const [hasSmartSummariesAccess, setSmartSummariesAccess] = useState(false);
  const [hasExportAccess, setHasExportAcess] = useState(false);
  const [hasNotesAccess, setHasNotesAccess] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [selectDefaultPeriod, setSelectDefaultPeriod] = useState([]);
  const [permissionPeriods, setPermissionPeriods] = useState([]);
  const [permissionKeys, setPermissionKeys] = useState([]);

  const closeEditPermissionsModal = () => {
    setEditPermissionModal(false)
    clearLocalState()
  }

  const openEditPermissions = (name, abbr) => {
    setModalBankName(name);
    setPermissionsAbbr(abbr);
    setEditPermissionModal(true);
    setIsDataLoading(true);
    var data = {
      'project': abbr,
      'permissionType': 'PERIODS'
    };
    const method = 'POST';
    return HttpRequest.fetch<any>('/scripts/access_control/getPermissions', { data, method })
      .then((res) => {
        setIsDataLoading(false);
        setDefaultPeriod(res.defaultPeriod);
        setFlagAbility(res.flagAbility);
        setHasAccessToCustomDateRanges(res.hasAccessToCustomDateRanges);
        setHasExportAcess(res.hasExportAccess);
        setHasApiAccess(res.hasApiAccess);
        setHasMFAEnabled(res.hasMFA_Enabled);
        setHasNotesAccess(res.hasNotesAccess);
        setPermissions(res.permissions);
        setSelectDefaultPeriod(res.permissionPeriodsArray);
        setPermissionPeriods(res.permissionPeriodsChecked);
        setSelfServeAbility(res.hasSelfServiceEnabled);
        setSmartSummariesAccess(res.hasSmartSummariesManagementAccess);
        setUsesSampleApp(res.usesSampleApp);

        if (res.permissionPeriodsChecked) {
          let newPermissionPeriodsKey = []
          let permissionPeriods = res.permissionPeriodsChecked
          for (var i = 0; i < permissionPeriods.length; i++) {
            var permission = permissionPeriods[i];
            if (permission.checked) {
              newPermissionPeriodsKey.push(permission.key);
            }
          }
          setPermissionKeys(newPermissionPeriodsKey);
        }
      })

  }

  const periodPermissionsChange = (key, checked) => {
    const periodKey = key;
    const periodChecked = !checked;
    let newPermissionPeriods = [];
    let newPermissionPeriodsKey = []
    for (var i = 0; i < permissionPeriods.length; i++) {
      var permission = permissionPeriods[i];
      if (permission.key === periodKey) {
        const obj = { 'key': permission.key, 'period': permission.period, 'checked': periodChecked };
        newPermissionPeriods.push(obj);
        if (periodChecked) {
          newPermissionPeriodsKey.push(periodKey);
        }
      }
      else {
        const obj = { 'key': permission.key, 'period': permission.period, 'checked': permission.checked };
        newPermissionPeriods.push(obj);
        if (permission.checked) {
          newPermissionPeriodsKey.push(permission.key);
        }
      }
    }
    setPermissionPeriods(newPermissionPeriods);
    setPermissionKeys(newPermissionPeriodsKey);
  }

  const savePermissions = () => {
    setIsDataLoading(true);
    const data = {
      project: permissionsAbbr,
      principal: permissionsAbbr,
      resource: permissionsAbbr,
      permissions: JSON.stringify(permissionKeys),
      defaultPeriod,
      flagComments: Boolean(flagAbility) ? 1 : 0,
      hasNotesAccess: Boolean(hasNotesAccess) ? 1 : 0,
      hasAccessToCustomDateRanges: Boolean(hasAccessToCustomDateRanges) ? 1 : 0,
      hasApiAccess: Boolean(hasApiAccess) ? 1 : 0,
      hasExportAccess: Boolean(hasExportAccess) ? 1 : 0,
      hasMFAEnabled: Boolean(hasMFAEnabled) ? 1 : 0,
      hasSelfServeAbility: Boolean(hasSelfServeAbility) ? 1 : 0,
      hasSmartSummariesAccess: Boolean(hasSmartSummariesAccess) ? 1 : 0,
    };
    const method = 'POST';
    return HttpRequest.fetch<any>('/scripts/access_control/savePermissions', { data, method })
      .then((res) => {
        setIsDataLoading(false);
        setEditPermissionModal(false)
        setMessage(res.message);
        setTimeout(() => {
          dispatch(loadAllClients(allClientStatus))
          setSearch("")
          clearLocalState()
        }, 100)
      })
  }

  //Adds the client to the ETL Table
  const addToETL = (client) => {
    setIsDataLoading(true);
    var data = {
      'client': client,
    };
    const method = 'POST';
    return HttpRequest.fetch<any>('/scripts/clients/add_to_new_etl', { data, method })
      .then((res) => {
        setMessage(res.message);
        setTimeout(() => {
          dispatch(loadAllClients(allClientStatus))
          setSearch("")
          clearLocalState()
        }, 100)
      })
  }

  //Syncs all super users with all clients
  const syncSuperUsers = () => {
    setIsSyncSuperUsersModalOpen(true);
    setIsDataLoading(true);
    const method = 'POST';
    return HttpRequest.fetch<any>('/scripts/clients/sync_super_users', { method })
      .then((res) => {
        setIsDataLoading(false);
        setIsSyncSuperUsersModalOpen(false);
        setMessage(res.message);
      })
      .catch((err) => {
        setIsDataLoading(false);
        setIsSyncSuperUsersModalOpen(false);
        setMessage('Error syncing super users. Please try again.');
      })
  }

  return (
    <div>
      <div style={{ margin: '10px' }}>
        <label>Version &nbsp;{webAppVersion}</label>
        <ClientTable
          isLoading={isLoading}
          customerTypes={customerTypes}
          setNewClientModal={setNewClientModal}
          search={search}
          setSearch={setSearch}
          allClientsStatusHandleChange={allClientsStatusHandleChange}
          allClientStatus={allClientStatus}
          message={message}
          setMessage={setMessage}
          filteredClients={filteredClients}
          modifyCustomerType={modifyCustomerType}
          modifyDynamicAge={modifyDynamicAge}
          redirectToQuestionnaires={redirectToQuestionnaires}
          loadIpRestrictions={loadIpRestrictions}
          getCategories={getCategories}
          openEditPermissions={openEditPermissions}
          openDashboardModal={toggleDashboardModal}
          addToETL={addToETL}
          syncSuperUsers={syncSuperUsers}
        />

        {/* Add New Client Modal */}
        {newClientModal ?
          <NewClient
            isLoading={isDataLoading}
            bankName={modalBankName}
            bankAbbr={modalAbbr}
            setBankAbbr={setModalAbbr}
            setBankName={setModalBankName}
            setNewClientModal={setNewClientModal}
            addNewClient={addNewClient}
          />
          : ""}

        {/* Client Type Modal */}
        {clientTypeModal ?
          <CustomerType
            isLoading={isDataLoading}
            customerTypes={customerTypes}
            bankName={modalBankName}
            modalCustomerTypeValue={modalCustomerTypeValue}
            modalAbbr={modalAbbr}
            modalCustomerType={modalCustomerType}
            allClientData={allClientData}
            setClientTypeModal={setClientTypeModal}
            customerTypeHandleChange={customerTypeHandleChange}
            saveCustomerClientType={saveCustomerClientType}
          />
          : ''}

        {/* Modal Dynamic Age */}
        {dynamicAgeModal ?
          <DynamicAge
            isLoading={isDataLoading}
            bankName={modalBankName}
            dynamicAge={dynamicAge}
            setDynamicAgeModal={setDynamicAgeModal}
            handleInputCounter={handleInputCounter}
            saveDynamicAge={saveDynamicAge}
          />
          : ''}

        {/* Default Dashboard */}
        <Modal open={isDashboardModalOpen}>
          {allClients.selectedClient &&
            <DashboardSelectorComponent
              clientAbbr={allClients.selectedClient.abbr}
              clientName={allClients.selectedClient.name}
              defaultDashboard={allClients.selectedClient.default_page_id}
              toggleDashboardModal={() => toggleDashboardModal()}
              clearSearch={setSearch}
            />
          }
        </Modal>
        {/* IP MODAL */}
        {ipRestrictionModal ?
          <IpAccess
            isLoading={isDataLoading}
            modalBankName={modalBankName}
            setAddIpModal={setAddIpModal}
            addIpModal={addIpModal}
            ipAddress={ipAddress}
            ipAddressHandleOnChange={ipAddressHandleOnChange}
            saveIpRestrictionModal={saveIpRestrictionModal}
            ipRestriction={ipRestriction}
            removeIpRestriction={removeIpRestriction}
            closeIPModal={closeIPModal}
          />
          : ''}
        {/* Edit Permission Modal*/}
        {editPermissionModal ?
          <EditPermission
            isLoading={isDataLoading}
            bankName={modalBankName}
            permissionPeriods={permissionPeriods}
            periodPermissionsChange={periodPermissionsChange}
            setDefaultPeriod={setDefaultPeriod}
            defaultPeriod={defaultPeriod}
            selectDefaultPeriod={selectDefaultPeriod}
            hasNotesAccess={hasNotesAccess}
            setHasNotesAccess={setHasNotesAccess}
            flagAbility={flagAbility}
            setFlagAbility={setFlagAbility}
            hasAccessToCustomDateRanges={hasAccessToCustomDateRanges}
            setHasAccessToCustomDateRanges={setHasAccessToCustomDateRanges}
            hasApiAccess={hasApiAccess}
            setHasApiAccess={setHasApiAccess}
            hasExportAccess={hasExportAccess}
            setHasExportAccess={setHasExportAcess}
            savePermissions={savePermissions}
            closeEditPermissionsModal={closeEditPermissionsModal}
            hasMFAEnabled={hasMFAEnabled}
            setHasMFAEnabled={setHasMFAEnabled}
            setSelfServeAbility={setSelfServeAbility}
            hasSelfServeAbility={hasSelfServeAbility}
            setHasSmartSummariesAccess={setSmartSummariesAccess}
            hasSmartSummariesAccess={hasSmartSummariesAccess}
          />
          : ''}
        {/* Edit Customer Modal */}
        {editClientModal ?
          <EditClient
            isLoading={isDataLoading}
            handleInputCounter={handleInputCounter}
            dynamicAge={dynamicAge}
            modalBankName={modalBankName}
            setModalBankName={setModalBankName}
            modalAbbr={modalAbbr}
            setModalAbbr={setModalAbbr}
            domain={domain}
            setDomain={setDomain}
            modalStatus={modalStatus}
            setModalStatus={setModalStatus}
            customerTypeHandleChange={customerTypeHandleChange}
            customerTypes={customerTypes}
            modalCustomerTypeValue={modalCustomerTypeValue}
            baseQuestions={baseQuestions}
            setBaseQuestion={setBaseQuestion}
            classicQuestions={classicQuestions}
            classicQuestionAttribute={classicQuestionAttribute}
            editCommentCodes={editCommentCodes}
            setEditCommentCodes={setEditCommentCodes}
            editDetails={editDetails}
            setEditDetails={setEditDetails}
            rankingReport={rankingReport}
            setRankingReport={setRankingReport}
            advanceActionAlert={advanceActionAlert}
            setAdvanceActionAlert={setAdvanceActionAlert}
            actionAlerts={actionAlerts}
            setActionAlerts={setActionAlerts}
            individualSurveysDelete={individualSurveysDelete}
            setIndividualSurveysDelete={setIndividualSurveysDelete}
            respondentName={respondentName}
            setRespondentName={setRespondentName}
            respondentEmail={respondentEmail}
            setRespondentEmail={setRespondentEmail}
            respondentPhone={respondentPhone}
            setRespondentPhone={setRespondentPhone}
            allSurveyHandleChange={allSurveyHandleChange}
            selectAllSurveyValue={selectAllSurveyValue}
            allSurveyQuestions={allSurveyQuestions}
            singleSurveyHandleChange={singleSurveyHandleChange}
            singleSurveyQuestions={singleSurveyQuestions}
            selectSingleSurvey={selectSingleSurvey}
            updateClient={updateClient}
            closeEditClientModal={closeEditClientModal}
            usesSampleApp={usesSampleApp}
            setUsesSampleApp={setUsesSampleApp}
            jhInstRouteId={jhInstRouteId}
            setJhInstRouteId={setJhInstRouteId}
            jhInstEnv={jhInstEnv}
            setJhInstEnv={setJhInstEnv}

          />
          : ''}

        {/* Sync Super Users Loading Modal */}
        <Modal open={isSyncSuperUsersModalOpen}>
          <div className="modal-content" style={{ textAlign: 'center', padding: '30px' }}>
            <h4>Syncing Super Users</h4>
            <p>This process may take 1-2 minutes to complete. Please wait...</p>
            <div className="progress">
              <div className="indeterminate"></div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  )
}
